import React from "react"
import "./Loading.scss"

const Loading = props => {
  return (
    <div className="Loading">
      <div className="outer-circle" />
      <div className="middle-circle" />
      <div className="inner-circle" />
    </div>
  )
}

export default Loading
